import {getBannerStatLogger, getErrorOperationWithSuffix} from '../util/BannerStat';
import type {SimpleBanner} from '../variant/SimpleBanner';

import type {IRefreshTrigger} from './IRefreshTrigger';

export class LoggingTrigger implements IRefreshTrigger {
    delegate: IRefreshTrigger | null;
    place: string | null;
    slot: string | null;

    constructor(delegate: IRefreshTrigger | null = null, place: string | null = null, slot: string | null = null) {
        this.delegate = delegate;
        this.place = place;
        this.slot = slot;
    }

    init(visible: boolean) {
        try {
            this.delegate?.init(visible);
        } catch (ex) {
            this.logAndRethrow(ex as Error, "init");
        }
    }

    show() {
        try {
            this.delegate?.show();
        } catch (ex) {
            this.logAndRethrow(ex as Error, "show");
        }
    }

    hide() {
        try {
            this.delegate?.hide();
        } catch (ex) {
            this.logAndRethrow(ex as Error, "hide");
        }
    }

    destroy() {
        try {
            this.delegate?.destroy();
        } catch (ex) {
            this.logAndRethrow(ex as Error, "destroy");
        }
    }

    attach(simpleBanner: SimpleBanner) {
        this.delegate?.attach(simpleBanner);
    }

    logAndRethrow(ex: Error, method: string) {
        getBannerStatLogger().errorEx(
            ex,
            'SimpleBanner',
            `${this.place}-${method}`,
            getErrorOperationWithSuffix(this.slot)
        );
        throw ex;
    }
}
